import { gql } from '@apollo/client';

export const GetEnterpriseList = gql`
  query GetEnterprises {
    getEnterprises {
      id
      name
      status
      url
      address1
      address2
      createdOn
      enterpriseEmployeeStats {
        total
      }
      enterpriseLogo {
        id
        presignedURL
      }
    }
    getOverallEnterpriseStat {
      active
      total
    }
  }
`;
export const GetEnterpriseByID = gql`
  query GetEnterpriseById($getEnterpriseByIdId: ID!) {
    getEnterpriseById(id: $getEnterpriseByIdId) {
      address1
      address2
      createdBy
      createdOn
      id
      logoId
      name
      status
      url
    }
    getEnterpriseClientsByEnterpriseId(id: $getEnterpriseByIdId) {
      id
      createdOn
      createdBy
      email
      enterprise {
        address1
        address2
        id
        name
        status
        url
      }
      firstName
      inviteStatus
      lastName
      phoneNumber
      role
      status
      lastSeen
    }
    getEnterpriseEmployeeStatsByEnterpriseId(id: $getEnterpriseByIdId) {
      total
      registered
      active
      totalInviteSent
    }
  }
`;

export const GetInvitedEnterpriseClientById = gql`
  query GetInvitedEnterpriseClientById($getInvitedEnterpriseClientByIdId: ID!) {
    getInvitedEnterpriseClientById(id: $getInvitedEnterpriseClientByIdId) {
      id
      firstName
      lastName
      phoneNumber
      email
      role
      enterprise {
        id
        name
        status
        url
        enterpriseLogo {
          presignedURL
        }
      }
    }
  }
`;

export const GetEnterpriseClientById = gql`
  query GetEnterpriseClientById($getEnterpriseClientByIdId: ID!) {
    getEnterpriseClientById(id: $getEnterpriseClientByIdId) {
      email
      phoneNumber
      firstName
      lastName
      role
      status
      inviteStatus
      id
      createdOn
      emailNotification
      textNotification
      enterpriseEmployeeStats {
        active
        registered
        total
        totalInviteSent
      }
    }
  }
`;

export const GetEnterpriseClientStats = gql`
  query GetEnterpriseClientStats {
    getEnterpriseClientStats {
      totalUsers
    }
  }
`;

export const GetEnterpriseEmployees = gql`
  query GetEnterpriseEmployees {
    getEnterpriseEmployees {
      firstName
      lastName
      email
      employeeId
      id
      phoneNumber
      appStatus
      status
    }
  }
`;

export const GetUploadedHistoryByEnterpriseId = gql`
query GetUploadedHistoryByEnterpriseId($getUploadedHistoryByEnterpriseIdId: ID!) {
  getUploadedHistoryByEnterpriseId(id: $getUploadedHistoryByEnterpriseIdId) {
    file {
      fileName
      id
      presignedURL
    }
    id
    status
    errorRecords {
      message
      row
    }
    createdOn
    uploadedEmployeeStat {
      total
      new
      duplicate
      modified
      error
    }
  }
}
`;

export const GetUploadEnterpriseEmployeeMappings = gql`
  query GetUploadEnterpriseEmployeeMappings($fileId: ID!) {
    getUploadEnterpriseEmployeeMappings(fileId: $fileId) {
      csvHeaders
      mappings {
        address
        email
        employeeId
        firstName
        id
        lastName
        phoneNumber
        ssn
      }
    }
  }
`;

export const GetEnterpriseEmployeesByEnterpriseId = gql`
  query GetEnterpriseEmployeesByEnterpriseId(
    $getEnterpriseEmployeesByEnterpriseIdId: ID!
  ) {
    getEnterpriseEmployeesByEnterpriseId(
      id: $getEnterpriseEmployeesByEnterpriseIdId
    ) {
      employeeId
      firstName
      lastName
      phoneNumber
      appStatus
      status
      email
      id
    }
  }
`;

export const GetSingleEnterpriseByID = gql`
  query GetEnterpriseById($getEnterpriseByIdId: ID!) {
    getEnterpriseById(id: $getEnterpriseByIdId) {
      address1
      address2
      createdBy
      createdOn
      id
      logoId
      name
      status
      url
      enterpriseClients {
        enterprise {
          enterpriseClients {
            id
          }
        }
      }
    }
  }
`;

// export const GetEnterpriseEmployeeStatsByEnterpriseId = gql `
// query GetEnterpriseEmployeeStatsByEnterpriseId($getEnterpriseEmployeeStatsByEnterpriseIdId: ID!) {
//   getEnterpriseEmployeeStatsByEnterpriseId(id: $getEnterpriseEmployeeStatsByEnterpriseIdId) {
//     total
//     registered
//     active
//     totalInviteSent
//   }
// }
// `
